import { Store, CheckCircle } from 'lucide-react';
import VendorRegistrationForm from '@/components/auth/VendorRegistrationForm';
import { useRegistrationData } from '@/hooks/auth/useRegistrationData';

const VendorRegistration = () => {
    const {
        step,
        getValues,
        register,
        errors,
        handleSubmit,
        onSubmit,
        watch,

        showPassword,
        setShowPassword,
        toggleCuisine,
        handleNextStep,
        handlePreviousStep,
        loading,
    } = useRegistrationData();

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl w-full space-y-8">
                {/* Header */}
                <div className="text-center">
                    <div className="flex justify-center">
                        <div className="flex items-center justify-center w-16 h-16 bg-primary-100 rounded-full">
                            <Store className="w-8 h-8 text-primary-600" />
                        </div>
                    </div>
                    <h2 className="mt-6 text-3xl font-bold text-gray-900">Join VLDL as a Vendor</h2>
                    <p className="mt-2 text-sm text-gray-600">
                        Start your digital restaurant journey with us
                    </p>

                    {/* Progress indicator */}
                    <div className="mt-6 flex justify-center">
                        <div className="flex items-center space-x-4">
                            <div
                                className={`flex items-center justify-center w-8 h-8 rounded-full ${step >= 1 ? 'bg-primary-600 text-white' : 'bg-gray-200 text-gray-500'
                                    }`}
                            >
                                {step > 1 ? <CheckCircle className="w-4 h-4" /> : '1'}
                            </div>
                            <div className={`w-16 h-1 ${step >= 2 ? 'bg-primary-600' : 'bg-gray-200'}`} />
                            <div
                                className={`flex items-center justify-center w-8 h-8 rounded-full ${step >= 2 ? 'bg-primary-600 text-white' : 'bg-gray-200 text-gray-500'
                                    }`}
                            >
                                2
                            </div>
                        </div>
                    </div>
                </div>

                <VendorRegistrationForm
                    step={step}
                    getValues={getValues}
                    register={register}
                    errors={errors}
                    handleSubmit={handleSubmit}
                    onSubmit={onSubmit}
                    showPassword={showPassword}
                    setShowPassword={setShowPassword}
                    toggleCuisine={toggleCuisine}
                    handleNextStep={handleNextStep}
                    handlePreviousStep={handlePreviousStep}
                    loading={loading}
                    watch={watch}
                />

                <div className="text-center">
                    <p className="text-sm text-gray-600">
                        By creating an account, you agree to our{' '}
                        <a href="/terms" className="font-medium text-primary-600 hover:text-primary-500">
                            Terms of Service
                        </a>{' '}
                        and{' '}
                        <a href="/privacy" className="font-medium text-primary-600 hover:text-primary-500">
                            Privacy Policy
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default VendorRegistration;
